import styled from 'styled-components'
import Hero from '../../assets/hero.jpg'

export const Homepage = styled.div`
  background: linear-gradient(rgba(77, 70, 70, 0.2), rgba(77, 70, 70, 0.2)), url(${Hero}) no-repeat 100% / cover;
  height: calc(var(--vh) * 100);
  width: 100vw;
  overflow: hidden;

  .content {
    height: calc(var(--vh) * 100);
  }

  .skew-bg {
    height: calc(var(--vh) * 100);
    padding: 0 5%;
    background-color: rgb(245, 175, 23);
    transform: skew(-10deg, 0);
    margin-right: -5%;

    .skew-content {
      transform: skew(10deg, 0);
    }
  }

  @media screen and (max-width: 1000px) {
    /* background-size: contain; */
    background: rgb(245, 175, 23);

    .skew-bg,
    .skew-bg .skew-content {
      transform: none;
      background-color: rgb(245, 175, 23);
      margin: 0;
    }

    .skew-content {
      align-items: center;
    }

    .login-panel {
      width: 100vw;
    }

    .homepage {
      justify-content: center;
    }
  }
`
